import Country from "../../resources/flags/Country.png";
import USA from "../../resources/flags/USA.png";
import China from "../../resources/flags/China.png";
import Germany from "../../resources/flags/Germany.png";
import Japan from "../../resources/flags/Japan.png";
import India from "../../resources/flags/India.png";
import UK from "../../resources/flags/UK.png";
import France from "../../resources/flags/France.png";
import Italy from "../../resources/flags/Italy.png";
import Brazil from "../../resources/flags/Brazil.png";
import Canada from "../../resources/flags/Canada.png";
import Mexico from "../../resources/flags/Mexico.png";
import Russia from "../../resources/flags/Russia.png";
import Korea from "../../resources/flags/Korea.png";
import Australia from "../../resources/flags/Australia.png";
import Spain from "../../resources/flags/Spain.png";
import Indonesia from "../../resources/flags/Indonesia.png";
import Turkey from "../../resources/flags/Turkey.png";
import Netherlands from "../../resources/flags/Netherlands.png";
import SaudiArabia from "../../resources/flags/Saudi Arabia.png";
import Switzerland from "../../resources/flags/Switzerland.png";
import Poland from "../../resources/flags/Poland.png";
import Taiwan from "../../resources/flags/Taiwan.png";
import Belgium from "../../resources/flags/Belgium.png";
import Argentina from "../../resources/flags/Argentina.png";
import Ireland from "../../resources/flags/Ireland.png";
import Sweden from "../../resources/flags/Sweden.png";
import Norway from "../../resources/flags/Norway.png";
import Austria from "../../resources/flags/Austria.png";
import Thailand from "../../resources/flags/Thailand.png";
import Israel from "../../resources/flags/Israel.png";
import UnitedArabEmirates from "../../resources/flags/United Arab Emirates.png";
import Singapore from "../../resources/flags/Singapore.png";
import Philippines from "../../resources/flags/Philippines.png";
import Vietnam from "../../resources/flags/Vietnam.png";
import Malaysia from "../../resources/flags/Malaysia.png";
import Bangladesh from "../../resources/flags/Bangladesh.png";
import Denmark from "../../resources/flags/Denmark.png";
import HongKongSAR from "../../resources/flags/Hong Kong SAR.png";
import SouthAfrica from "../../resources/flags/South Africa.png";
import Nigeria from "../../resources/flags/Nigeria.png";
import Iran from "../../resources/flags/Iran.png";
import Romania from "../../resources/flags/Romania.png";
import Colombia from "../../resources/flags/Colombia.png";
import CzechRepublic from "../../resources/flags/Czech Republic.png";
import Egypt from "../../resources/flags/Egypt.png";
import Chile from "../../resources/flags/Chile.png";
import Pakistan from "../../resources/flags/Pakistan.png";
import Finland from "../../resources/flags/Finland.png";
import Kazakhstan from "../../resources/flags/Kazakhstan.png";
import Portugal from "../../resources/flags/Portugal.png";
import Peru from "../../resources/flags/Peru.png";
import Iraq from "../../resources/flags/Iraq.png";
import Greece from "../../resources/flags/Greece.png";
import NewZealand from "../../resources/flags/New Zealand.png";
import Qatar from "../../resources/flags/Qatar.png";
import Algeria from "../../resources/flags/Algeria.png";
import Hungary from "../../resources/flags/Hungary.png";
import Ethiopia from "../../resources/flags/Ethiopia.png";
import Ukraine from "../../resources/flags/Ukraine.png";
import Kuwait from "../../resources/flags/Kuwait.png";
import Morocco from "../../resources/flags/Morocco.png";
import SlovakRepublic from "../../resources/flags/Slovak Republic.png";
import DominicanRepublic from "../../resources/flags/Dominican Republic.png";
import Ecuador from "../../resources/flags/Ecuador.png";
import Cuba from "../../resources/flags/Cuba.png";
import PuertoRico from "../../resources/flags/Puerto Rico.png";
import Kenya from "../../resources/flags/Kenya.png";
import Oman from "../../resources/flags/Oman.png";
import Guatemala from "../../resources/flags/Guatemala.png";
import Bulgaria from "../../resources/flags/Bulgaria.png";
import Uzbekistan from "../../resources/flags/Uzbekistan.png";
import Venezuela from "../../resources/flags/Venezuela.png";
import Luxembourg from "../../resources/flags/Luxembourg.png";
import Angola from "../../resources/flags/Angola.png";
import CostaRica from "../../resources/flags/Costa Rica.png";
import Turkmenistan from "../../resources/flags/Turkmenistan.png";
import Panama from "../../resources/flags/Panama.png";
import Coted from "../../resources/flags/Côte d'Ivoire.png";
import Croatia from "../../resources/flags/Croatia.png";
import Lithuania from "../../resources/flags/Lithuania.png";
import Tanzania from "../../resources/flags/Tanzania.png";
import Serbia from "../../resources/flags/Serbia.png";
import Uruguay from "../../resources/flags/Uruguay.png";
import Azerbaijan from "../../resources/flags/Azerbaijan.png";
import Myanmar from "../../resources/flags/Myanmar.png";
import Ghana from "../../resources/flags/Ghana.png";
import SriLanka from "../../resources/flags/Sri Lanka.png";
import Slovenia from "../../resources/flags/Slovenia.png";
import CongoDemRepofthe from "../../resources/flags/Congo, Dem. Rep. of the.png";
import Belarus from "../../resources/flags/Belarus.png";
import Syria from "../../resources/flags/Syria.png";
import Uganda from "../../resources/flags/Uganda.png";
import Tunisia from "../../resources/flags/Tunisia.png";
import Cameroon from "../../resources/flags/Cameroon.png";
import Jordan from "../../resources/flags/Jordan.png";
import MacaoSAR from "../../resources/flags/Macao SAR.png";
import Latvia from "../../resources/flags/Latvia.png";
import Bolivia from "../../resources/flags/Bolivia.png";
import Bahrain from "../../resources/flags/Bahrain.png";
import Zimbabwe from "../../resources/flags/Zimbabwe.png";
import Paraguay from "../../resources/flags/Paraguay.png";
import Nepal from "../../resources/flags/Nepal.png";
import Estonia from "../../resources/flags/Estonia.png";
import Libya from "../../resources/flags/Libya.png";
import ElSalvador from "../../resources/flags/El Salvador.png";
import Honduras from "../../resources/flags/Honduras.png";
import Senegal from "../../resources/flags/Senegal.png";
import Iceland from "../../resources/flags/Iceland.png";
import Cyprus from "../../resources/flags/Cyprus.png";
import Cambodia from "../../resources/flags/Cambodia.png";
import PapuaNewGuinea from "../../resources/flags/Papua New Guinea.png";
import Georgia from "../../resources/flags/Georgia.png";
import Zambia from "../../resources/flags/Zambia.png";
import TrinidadandTobago from "../../resources/flags/Trinidad and Tobago.png";
import BosniaandHerzegovina from "../../resources/flags/Bosnia and Herzegovina.png";
import Haiti from "../../resources/flags/Haiti.png";
import Armenia from "../../resources/flags/Armenia.png";
import Sudan from "../../resources/flags/Sudan.png";
import Guinea from "../../resources/flags/Guinea.png";
import Albania from "../../resources/flags/Albania.png";
import Mozambique from "../../resources/flags/Mozambique.png";
import Mali from "../../resources/flags/Mali.png";
import BurkinaFaso from "../../resources/flags/Burkina Faso.png";
import Botswana from "../../resources/flags/Botswana.png";
import Yemen from "../../resources/flags/Yemen.png";
import Benin from "../../resources/flags/Benin.png";
import Lebanon from "../../resources/flags/Lebanon.png";
import Malta from "../../resources/flags/Malta.png";
import Guyana from "../../resources/flags/Guyana.png";
import Jamaica from "../../resources/flags/Jamaica.png";
import Gabon from "../../resources/flags/Gabon.png";
import Mongolia from "../../resources/flags/Mongolia.png";
import Niger from "../../resources/flags/Niger.png";
import Nicaragua from "../../resources/flags/Nicaragua.png";
import WestBankandGaza from "../../resources/flags/West Bank and Gaza.png";
import NorthMacedonia from "../../resources/flags/North Macedonia.png";
import Moldova from "../../resources/flags/Moldova.png";
import Madagascar from "../../resources/flags/Madagascar.png";
import Mauritius from "../../resources/flags/Mauritius.png";
import BruneiDarussalam from "../../resources/flags/Brunei Darussalam.png";
import CongoRepublicof from "../../resources/flags/Congo, Republic of .png";
import Afghanistan from "../../resources/flags/Afghanistan.png";
import BahamasThe from "../../resources/flags/Bahamas, The.png";
import LaoPDR from "../../resources/flags/Lao.png";
import Rwanda from "../../resources/flags/Rwanda.png";
import KyrgyzRepublic from "../../resources/flags/Kyrgyz Republic.png";
import Namibia from "../../resources/flags/Namibia.png";
import Chad from "../../resources/flags/Chad.png";
import Tajikistan from "../../resources/flags/Tajikistan.png";
import Somalia from "../../resources/flags/Somalia.png";
import Kosovo from "../../resources/flags/Kosovo.png";
import Malawi from "../../resources/flags/Malawi.png";
import Mauritania from "../../resources/flags/Mauritania.png";
import EquatorialGuinea from "../../resources/flags/Equatorial Guinea.png";
import Togo from "../../resources/flags/Togo.png";
import Montenegro from "../../resources/flags/Montenegro.png";
import Maldives from "../../resources/flags/Maldives.png";
import SouthSudanRepublicof from "../../resources/flags/South Sudan, Republic of.png";
import Barbados from "../../resources/flags/Barbados.png";
import Fiji from "../../resources/flags/Fiji.png";
import Eswatini from "../../resources/flags/Eswatini.png";
import Liberia from "../../resources/flags/Liberia.png";
import Djibouti from "../../resources/flags/Djibouti.png";
import Suriname from "../../resources/flags/Suriname.png";
import Aruba from "../../resources/flags/Aruba.png";
import Andorra from "../../resources/flags/Andorra.png";
import SierraLeone from "../../resources/flags/Sierra Leone.png";
import Belize from "../../resources/flags/Belize.png";
import Bermuda from "../../resources/flags/Bermuda.png";
import Burundi from "../../resources/flags/Burundi.png";
import CentralAfricanRepublic from "../../resources/flags/Central African Republic.png";
import Bhutan from "../../resources/flags/Bhutan.png";
import CaboVerde from "../../resources/flags/Cabo Verde.png";
import GambiaThe from "../../resources/flags/Gambia, The.png";
import SaintLucia from "../../resources/flags/Saint Lucia.png";
import Lesotho from "../../resources/flags/Lesotho.png";
import GuineaBissau from "../../resources/flags/Guinea-Bissau.png";
import Seychelles from "../../resources/flags/Seychelles.png";
import AntiguaandBarbuda from "../../resources/flags/Antigua and Barbuda.png";
import SanMarino from "../../resources/flags/San Marino.png";
import TimorLeste from "../../resources/flags/Timor-Leste.png";
import Eritrea from "../../resources/flags/Eritrea.png";
import SolomonIslands from "../../resources/flags/Solomon Islands.png";
import Comoros from "../../resources/flags/Comoros.png";
import Grenada from "../../resources/flags/Grenada.png";
import Vanuatu from "../../resources/flags/Vanuatu.png";
import SaintKittsandNevis from "../../resources/flags/Saint Kitts and Nevis.png";
import SaintVincentandtheGrenadines from "../../resources/flags/Saint Vincent and the Grenadines.png";
import Samoa from "../../resources/flags/Samoa.png";
import SãoToméandPríncipe from "../../resources/flags/São Tomé and Príncipe.png";
import Dominica from "../../resources/flags/Dominica.png";
import Tonga from "../../resources/flags/Tonga.png";
import MicronesiaFedStatesof from "../../resources/flags/Micronesia, Fed. States of.png";
import Palau from "../../resources/flags/Palau.png";
import MarshallIslands from "../../resources/flags/Marshall Islands.png";
import Kiribati from "../../resources/flags/Kiribati.png";
import Nauru from "../../resources/flags/Nauru.png";
import Tuvalu from "../../resources/flags/Tuvalu.png";
import Curacao from "../../resources/flags/Curacao.png";
import Gibraltar from "../../resources/flags/Gibraltar.png";
import Greenland from "../../resources/flags/Greenland.png";
import Guam from "../../resources/flags/Guam.png";
import Liechtenstein from "../../resources/flags/Liechtenstein.png";
import Monaco from "../../resources/flags/Monaco.png";


const nameFlagMapping = {
    "Country": Country,
"USA": USA,
"China": China,
"Germany": Germany,
"Japan": Japan,
"India": India,
"UK": UK,
"France": France,
"Italy": Italy,
"Brazil": Brazil,
"Canada": Canada,
"Mexico": Mexico,
"Russia": Russia,
"Korea": Korea,
"Australia": Australia,
"Spain": Spain,
"Indonesia": Indonesia,
"Turkey": Turkey,
"Netherlands": Netherlands,
"Saudi Arabia": SaudiArabia,
"Switzerland": Switzerland,
"Poland": Poland,
"Taiwan": Taiwan,
"Belgium": Belgium,
"Argentina": Argentina,
"Ireland": Ireland,
"Sweden": Sweden,
"Norway": Norway,
"Austria": Austria,
"Thailand": Thailand,
"Israel": Israel,
"United Arab Emirates": UnitedArabEmirates,
"Singapore": Singapore,
"Philippines": Philippines,
"Vietnam": Vietnam,
"Malaysia": Malaysia,
"Bangladesh": Bangladesh,
"Denmark": Denmark,
"Hong Kong SAR": HongKongSAR,
"South Africa": SouthAfrica,
"Nigeria": Nigeria,
"Iran": Iran,
"Romania": Romania,
"Colombia": Colombia,
"Czech Republic": CzechRepublic,
"Egypt": Egypt,
"Chile": Chile,
"Pakistan": Pakistan,
"Finland": Finland,
"Kazakhstan": Kazakhstan,
"Portugal": Portugal,
"Peru": Peru,
"Iraq": Iraq,
"Greece": Greece,
"New Zealand": NewZealand,
"Qatar": Qatar,
"Algeria": Algeria,
"Hungary": Hungary,
"Ethiopia": Ethiopia,
"Ukraine": Ukraine,
"Kuwait": Kuwait,
"Morocco": Morocco,
"Slovak Republic": SlovakRepublic,
"Dominican Republic": DominicanRepublic,
"Ecuador": Ecuador,
"Puerto Rico": PuertoRico,
"Kenya": Kenya,
"Oman": Oman,
"Guatemala": Guatemala,
"Bulgaria": Bulgaria,
"Uzbekistan": Uzbekistan,
"Venezuela": Venezuela,
"Luxembourg": Luxembourg,
"Angola": Angola,
"Costa Rica": CostaRica,
"Turkmenistan": Turkmenistan,
"Panama": Panama,
"Côte d'Ivoire": Coted,
"Croatia": Croatia,
"Lithuania": Lithuania,
"Bermuda": Bermuda, 
"Tanzania": Tanzania,
"Serbia": Serbia,
"Uruguay": Uruguay,
"Azerbaijan": Azerbaijan,
"Myanmar": Myanmar,
"Ghana": Ghana,
"Sri Lanka": SriLanka,
"Slovenia": Slovenia,
"Congo, Dem. Rep. of the": CongoDemRepofthe,
"Belarus": Belarus,
"Syria": Syria,
"Uganda": Uganda,
"Tunisia": Tunisia,
"Cameroon": Cameroon,
"Jordan": Jordan,
"Macao SAR": MacaoSAR,
"Latvia": Latvia,
"Bolivia": Bolivia,
"Bahrain": Bahrain,
"Zimbabwe": Zimbabwe,
"Paraguay": Paraguay,
"Nepal": Nepal,
"Estonia": Estonia,
"Libya": Libya,
"El Salvador": ElSalvador,
"Honduras": Honduras,
"Senegal": Senegal,
"Iceland": Iceland,
"Cyprus": Cyprus,
"Cambodia": Cambodia,
"Papua New Guinea": PapuaNewGuinea,
"Georgia": Georgia,
"Zambia": Zambia,
"Trinidad and Tobago": TrinidadandTobago,
"Bosnia and Herzegovina": BosniaandHerzegovina,
"Haiti": Haiti,
"Armenia": Armenia,
"Sudan": Sudan,
"Guinea": Guinea,
"Albania": Albania,
"Mozambique": Mozambique,
"Mali": Mali,
"Burkina Faso": BurkinaFaso,
"Botswana": Botswana,
"Yemen": Yemen,
"Benin": Benin,
"Lebanon": Lebanon,
"Malta": Malta,
"Guyana": Guyana,
"Jamaica": Jamaica,
"Gabon": Gabon,
"Mongolia": Mongolia,
"Niger": Niger,
"Cuba": Cuba,
"Nicaragua": Nicaragua,
"West Bank and Gaza": WestBankandGaza,
"North Macedonia": NorthMacedonia,
"Moldova": Moldova,
"Madagascar": Madagascar,
"Mauritius": Mauritius,
"Brunei Darussalam": BruneiDarussalam,
"Congo, Republic of": CongoRepublicof,
"Afghanistan": Afghanistan,
"Bahamas, The": BahamasThe,
"Lao": LaoPDR,
"Rwanda": Rwanda,
"Kyrgyz Republic": KyrgyzRepublic,
"Namibia": Namibia,
"Chad": Chad,
"Tajikistan": Tajikistan,
"Somalia": Somalia,
"Kosovo": Kosovo,
"Malawi": Malawi,
"Mauritania": Mauritania,
"Equatorial Guinea": EquatorialGuinea,
"Togo": Togo,
"Montenegro": Montenegro,
"Maldives": Maldives,
"South Sudan, Republic of": SouthSudanRepublicof,
"Barbados": Barbados,
"Fiji": Fiji,
"Eswatini": Eswatini,
"Liberia": Liberia,
"Djibouti": Djibouti,
"Suriname": Suriname,
"Aruba": Aruba,
"Andorra": Andorra,
"Sierra Leone": SierraLeone,
"Belize": Belize,
"Burundi": Burundi,
"Central African Republic": CentralAfricanRepublic,
"Bhutan": Bhutan,
"Cabo Verde": CaboVerde,
"Gambia, The": GambiaThe,
"Saint Lucia": SaintLucia,
"Lesotho": Lesotho,
"Guinea-Bissau": GuineaBissau,
"Seychelles": Seychelles,
"Antigua and Barbuda": AntiguaandBarbuda,
"San Marino": SanMarino,
"Timor-Leste": TimorLeste,
"Eritrea": Eritrea,
"Solomon Islands": SolomonIslands,
"Comoros": Comoros,
"Grenada": Grenada,
"Vanuatu": Vanuatu,
"Saint Kitts and Nevis": SaintKittsandNevis,
"Saint Vincent and the Grenadines": SaintVincentandtheGrenadines,
"Samoa": Samoa,
"São Tomé and Príncipe": SãoToméandPríncipe,
"Dominica": Dominica,
"Tonga": Tonga,
"Micronesia, Fed. States of": MicronesiaFedStatesof,
"Palau": Palau,
"Marshall Islands": MarshallIslands,
"Kiribati": Kiribati,
"Nauru": Nauru,
"Tuvalu": Tuvalu,
"Curacao": Curacao,
"Gibraltar": Gibraltar,
"Greenland": Greenland,
"Guam": Guam,
"Liechtenstein": Liechtenstein,
"Monaco": Monaco

}


const GetFlag = (name) => {
        return nameFlagMapping[name];
        
    // return nameFlagMapping["Country"];
};

export default GetFlag;